import htmlvalidation from "../../../../assets/images/docs/htmlvalidation.png";
import * as React from 'react';
export default {
  htmlvalidation,
  React
};